<template>
    <div>
        <div id="data-list-list-view" class="data-list-container">
            <div class="vs-component vs-con-table vs-table-primary">
                <header class="header-table vs-table--header"></header>
                <div class="con-tablex vs-table--content">
                    <div v-if="Data" class="vs-con-tbody vs-table--tbody " style="overflow: auto;">
                        <div class="acr-welcome-message">
                          <h3>تراکنش های مالی من</h3>
                        </div>
                        <table id="productList" class="vs-table vs-table--tbody-table table-stripeed">
                            <thead class="vs-table--thead">
                                <tr>
                                    <th colspan="1" rowspan="1"> کد تراکنش</th>
                                    <th colspan="1" rowspan="1">تاریخ</th>
                                    <th colspan="1" rowspan="1">شماره سفارش</th>
                                    <th colspan="1" rowspan="1">مبلغ</th>
                                    <th colspan="1" rowspan="1">وضعیت</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item,index) in Data" :key="index">
                                <th colspan="1" rowspan="1">{{Data[index].id}}</th>
                                <th colspan="1" rowspan="1">{{Data[index].created_at | jdate}}</th>
                                <th colspan="1" rowspan="1">{{Data[index].id}}</th>
                                <th colspan="1" rowspan="1">{{Data[index].price | priceUnit}}</th>
                                <th colspan="1" rowspan="1">{{Data[index].sts === 1 ? 'در انتظار پرداخت' : 'پرداخت شده'}}</th>
                            </tr>
                            </tbody>
                        </table>
                        <pagination
                          v-model="page"
                          :total-pages="Math.ceil(count/limit)"
                          @pagechanged="onPageChange" />
                    </div>
                    <div class="not-data-table vs-table--not-data" v-if="flag"> تراکنشی موجود نمی باشد </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/plugins/axios'
import Pagination from "@/components/Pagination";
export default {
    props:{
        togglePreLoader: Function
    },
    components:{Pagination},
    data () {
        return {
            Data: undefined,
            Error: null,
            page:1,
            count:undefined,
            limit:10,
            flag:false
        }
    },
    watch:{
      Data(value){
        if(value.length<1){
          console.log(value)
          this.flag = true
        }
      }
    },
    methods:{
      async onPageChange(){
        try {
          this.togglePreLoader('open')
          // let {data} = await axios.post(`/cu/transaction`,{page:this.page,limit:this.limit})
          let {data} = await axios.post(`/cu/order/table`,{page:this.page,limit:this.limit})
          this.Data = data.rows
        } catch (error) {
          if (error.response && error.response.data.errors) {
            let str_error = ''
            for(let item of Object.values(error.response.data.errors))
            {
              item.map(xx=>{
                if (xx.includes("shipping address")){
                  str_error += xx.replace("shipping address","آدرس") + "<br/>"
                }
                else{
                  str_error += xx + "<br/>"
                }
              })
            }
            this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
          }
          else{
            if (error) {
              if(error == "Error: Network Error"){
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
              }
              else {
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
              }
            }
          }
        } finally {
          this.togglePreLoader('close')
        }
        let el = document.getElementById('productList')
        document.body.scrollTop = el.offsetTop - 150;
        document.documentElement.scrollTop = el.offsetTop - 150;
      },
    },
    async created () {
        try {
            this.togglePreLoader('open')
            let {data} = await axios ({
                method: 'post',
                url:`/cu/order/table`,
                headers: {}, 
                data: {page:this.page,limit:this.limit}
            })
            this.Data = data.rows
          this.count = data.query.total
        } catch (error) {
          if (error.response && error.response.data.errors) {
            let str_error = ''
            for(let item of Object.values(error.response.data.errors))
            {
              item.map(xx=>{
                if (xx.includes("shipping address")){
                  str_error += xx.replace("shipping address","آدرس") + "<br/>"
                }
                else{
                  str_error += xx + "<br/>"
                }
              })
            }
            this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
          }
          else{
            if (error) {
              if(error == "Error: Network Error"){
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
              }
              else {
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
              }
            }
          }
        } finally {
            this.togglePreLoader('close')
        }
    }
}
</script>

<style lang="css" scoped>
.vs-con-table {
    background: transparent;
}
.vs-table--content {
    overflow: inherit;
}
.vuesax-app-is-ltr .vs-pagination--buttons.vs-pagination--button-prev, .vuesax-app-is-rtl .vs-pagination--buttons.vs-pagination--button-next {
    margin-right: 5px;
}
</style>